import React from "react";
import styles from "./UpgradePlanChipStyle.module.css";
import { openPricingPage } from "utils/Utils";
import classnames from "classnames";

export const UpgradePlanChip = ({ text = "Upgrade Plan", className }) => {
  return (
    <div
      className={classnames(styles.container, className)}
      onClick={openPricingPage}
    >
      <div className={styles.text}>{text}</div>
    </div>
  );
};
